import React, { Fragment, useContext } from 'react';
import AppContext from '../../context/Context';
import RadarForContractor from './RadarForContractor.js'
import RadarForContractingBody from './RadarForContractingBody.js'
import RadarForAttorney from './RadarForAttorney.js'

const Radar = ({updateRequest}) => {    
    const { currentUser } = useContext(AppContext);  
  return (
    <Fragment>
      {{
        Auftragnehmer: <RadarForContractor />,
        Auftraggeber: <RadarForContractingBody />,
        Anwalt: <RadarForAttorney />,
      }[currentUser?.mainType ?? 'Auftragnehmer']}
    </Fragment>
  );
};

export default Radar;